import styled from "styled-components";

export const UserPaymentSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 2rem;

  h3 {
    font: 600 1rem "inter";
    color: ${({ theme }) => theme.console.pageSubtitleColor}!important;
  }
`;
